<template>
  <v-dialog :value="open" max-width="640" persistent>
    <v-card>
      <v-card-title>{{ $t('listaPreciosVenta.creating') }}</v-card-title>
      <v-card-text>
        <lista-precios-venta-form ref="form" v-model="form" />
        <v-alert v-if="error" type="error" dense class="mt-2">{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">{{ $t('common.cancel') }}</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListaPreciosVentaProvider from "../../../providers/ListaPreciosVentaProvider";
import ListaPreciosVentaForm from "../ListaPreciosVentaForm";

export default {
  name: "ListaPreciosVentaCreate",
  components: { ListaPreciosVentaForm },
  props: { open: Boolean },
  data() {
    return {
      saving: false,
      error: null,
      form: {
        nombre: "",
        formulaConfig: { formula: "", margenDefault: null, tipoRedondeo: null },
      },
    };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.error = null;
      const input = {
        nombre: this.form.nombre,
        formulaConfig: this.form.formulaConfig,
      };
      ListaPreciosVentaProvider.create(input)
        .then(() => this.$emit("itemCreated"))
        .then(() => this.$emit("close"))
        .catch((err) => {
          this.error = err.message;
        })
        .finally(() => (this.saving = false));
    },
  },
};
</script>
